import { FC } from 'react';
import Button from '@components/Button';
import Modal from '@components/Modal';
import cn from 'classnames';

import styles from './WhatIsThisModal.module.scss';

interface WhatIsThisModalProps {
  onClick: (open: boolean) => void;
}

const WhatIsThisModal: FC<WhatIsThisModalProps> = ({ onClick }) => {
  const firstDescription =
    'The world may be modern, but the rules of survival haven’t changed: predators and prey, survival of the fittest. Physical threats have evolved into psychological warfare. Scientists have weaponized this knowledge, handing it to social media, politicians, and marketers—anyone who can pay.';
  const secondDescription =
    'This project is your shield, helping you build defenses before it’s too late. Whether you’re navigating a hostile environment or planning your future, Darkhacks ensures you’re ready for the challenge.';
  const thirdDescription =
    'You don’t need another influencer; everything you need is already in your head. It’s time to use it.';

  return (
    <Modal
      hasBorder
      title={'What is this?'}
      onClick={() => onClick(false)}
      bodyClassName={styles.body}
    >
      <div className={styles.contentWrapper}>
        <p className={styles.text}>{firstDescription}</p>
        <br />
        <p className={styles.text}>{secondDescription}</p>
        <br />
        <p className={cn(styles.text, styles.lastText)}>{thirdDescription}</p>
      </div>
      <div className={styles.btnWrapper}>
        <Button
          label={'Understood'}
          onClick={() => onClick(false)}
          type={'primary'}
        />
      </div>
    </Modal>
  );
};

export default WhatIsThisModal;
